const s = require("./coreMap.module.scss");

import { default as React } from "react";
import classNames from "classnames";
import { CardStyle } from "./content";

interface OwnProps {
    row: number;
    col: number;
    out: number;
    in: number;
    cardStyle: CardStyle;
}

const HorizontalExchange = (props: OwnProps) => {
    const elementHeight = props.cardStyle.elementHeight;
    const elementWidth = props.cardStyle.elementWidth;
    const margin = props.cardStyle.margin;

    const height = 26;
    const width = 80;
    const top = ((props.row - 0.5) * elementHeight) + ((props.row - 1) * margin) - height;
    const left = (props.col * (elementWidth + margin)) - ((width + margin) / 2);
    return (
        <div className={s.horizontalExchange} style={{
            /*left: left + "px",
             top: top + "px",
             width: width + "px",*/
            gridColumn: props.col,
            gridRow: props.row,

        }}>
            <div className={classNames(s.horizontalLabel, s.arrowLeft)} style={{ minHeight: height + "px" }}>{(props.in && Math.floor(props.in)) ?? "-"}</div>
            <div className={classNames(s.horizontalLabel, s.arrowRight)} style={{ minHeight: height + "px" }}>{(props.out && Math.floor(props.out)) ?? "-"}</div>
        </div>
    );
};

export default HorizontalExchange;